import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

interface IInfoDialogConfig {
    content?: React.ReactNode;
    title: string;
}

export interface IInfoDialogState {
    config: IInfoDialogConfig | null;
}

const initialState: IInfoDialogState = {
    config: null,
};

const reducers = {
    update: (state: IInfoDialogState, action: PayloadAction<IInfoDialogConfig | null>) => {
        state.config = action.payload;
    },
};

export const infoDialogSlice = createSlice({
    name: 'infoDialog',
    initialState,
    reducers,
});

export const infoDialogConfig = (state: IGlobalStoreReducers) => state.infoDialog.config;

export const { update } = infoDialogSlice.actions;

export default infoDialogSlice.reducer;
